import { render, staticRenderFns } from "./addClasses.vue?vue&type=template&id=694c416b&scoped=true"
import script from "./addClasses.vue?vue&type=script&lang=js"
export * from "./addClasses.vue?vue&type=script&lang=js"
import style0 from "./addClasses.vue?vue&type=style&index=0&id=694c416b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c416b",
  null
  
)

export default component.exports